export const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard') 
  },  
  {
    path: '/v-articoli/:articolo?',
    name: 'Articoli',
    props: true,
    component: () => import(/* webpackChunkName: "articoli" */ '../views/articoli')
  },
  {
    path: '/v-clienti',
    name: 'Clienti',
    component: () => import(/* webpackChunkName: "clienti" */ '../views/clienti')
  },
  {
    path: '/v-movimenti',
    name: 'Movimenti',
    component: () => import(/* webpackChunkName: "movimenti" */ '../views/movimenti')
  },
  {
    path: '/v-documenti',
    name: 'Documenti',
    component: () => import(/* webpackChunkName: "documenti" */ '../views/documenti')
  },
  {
    path: '/v-ordini-cliente',
    name: 'Ordini',
    component: () => import(/* webpackChunkName: "ordiniCliente" */ '../views/ordiniCliente')
  },
  {
    path: '/v-ordini-fornitore',
    name: 'Ordini fornitore',
    component: () => import(/* webpackChunkName: "ordiniFornitore" */ '../views/ordiniFornitore')
  },  
  {
    path: '/v-documenti-edit',
    name: 'DocumentiEdit',
    component: () => import(/* webpackChunkName: "documentiEdit" */ '../views/documenti/components/edit/editDocumento')
  },
  {
    path: '/v-import',
    name: 'Import articoli',
    component: () => import(/* webpackChunkName: "import" */ '../views/import')
  },
  {
    path: '/v-import-generico',
    name: 'Import generico',
    component: () => import(/* webpackChunkName: "importGenerico" */ '../views/importGenerico')
  },
  {
    path: '/v-export-dati',
    name: 'Export dati',
    component: () => import(/* webpackChunkName: "exportDati" */ '../views/exportDati')
  },
  {
    path: '/v-import-dati',
    name: 'Import dati',
    component: () => import(/* webpackChunkName: "importDati" */ '../views/importDati')
  },
  {
    path: '/v-inventario',
    name: 'Inventario',
    component: () => import(/* webpackChunkName: "inventario" */ '../views/inventario')
  },
  {
    path: '/v-fe-emesse',
    name: 'fatturazioneElettronicaEmesse',
    component: () => import(/* webpackChunkName: "fatturazioneElettronica" */ '../views/fatturazioneElettronica/fattureEmesse')
  },
  {
    path: '/v-fe-ricevute',
    name: 'fatturazioneElettronicaRicevute',
    component: () => import(/* webpackChunkName: "fatturazioneElettronica" */ '../views/fatturazioneElettronica/fattureRicevute')
  },  
  {
    path: '/v-autofatture',
    name: 'autofatture',
    component: () => import(/* webpackChunkName: "autofattura" */ '../views/fatturazioneElettronica/autofatture')
  },  
  {
    path: '/v-ecommerce',
    name: 'eCommerce',
    component: () => import(/* webpackChunkName: "eCommerce" */ '../views/eCommerce')
  },
  {
    path: '/v-park',
    name: 'park',
    component: () => import(/* webpackChunkName: "park" */ '../views/park')
  },   
  {
    path: '/v-lotti',
    name: 'Lotti',
    component: () => import(/* webpackChunkName: "lotti" */ '../views/lotti')
  }, 
  {
    path: '/v-distinta-base',
    name: 'DistintaBase',
    component: () => import(/* webpackChunkName: "distintaBase" */ '../views/distintaBase')
  },
  {
    path: '/v-primanota',
    name: 'PrimaNota',
    component: () => import(/* webpackChunkName: "primaNota" */ '../views/contabilita/primaNota')
  }
]